import React from 'react';
import "./Home.css";
import Cta from './Cta';
function Blogs(props) {
    return (
        <>{ /*===== BLOG AREA STARTS =======*/ }
<div className="vl-blog-4-area sp2">
    <div className="container">
       <div className="row">
          <div className="col-lg-5 m-auto">
             <div className="vl-blog-1-section-box heading4 text-center space-margin60">
                <h5 className="vl-section-subtitle">JEEVANDAAN Hospital<span> | </span>Our Blogs <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                    <path d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992" stroke="#b2442c" strokeWidth={1.5} />
                  </svg>
                </h5>
                <div className="space24" />
                <h2 className="vl-section-title text-anime-style-3">From Our Blog</h2>
             </div>
          </div>
       </div>
       <div className="row">
        <div className="col-lg-4  col-md-6" data-aos="fade-left" data-aos-duration="900">
          <div className="vl-blog-1-item">
             <div className="vl-blog-1-thumb image-anime">
                <img src="assets/img/all-images/blog/blog-img6.png" alt="" />
             </div>
             <div className="vl-blog-1-content">
              <div className="vl-blog-meta">
                 <ul>
                  <li>
                    <a href="#">Articles</a>
                </li>
                 </ul>
              </div>
              <div className="space16" />
              <h4 className="vl-blog-1-title"><a href="blog-single.html">Personal Branding For Consultants: Be Authentic To Get More Clients.</a></h4>
              <div className="space28" />
              <div className="vl-blog-1-icon">
                <a href="blog-single.html" className="learnmore">Learn More
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.99992 0.833496C4.04188 0.833496 0.833252 4.04212 0.833252 8.00016C0.833252 11.9582 4.04188 15.1668 7.99992 15.1668C11.958 15.1668 15.1666 11.9582 15.1666 8.00016C15.1666 4.04212 11.958 0.833496 7.99992 0.833496ZM7.33325 5.3335C7.06359 5.3335 6.82052 5.49592 6.71732 5.74504C6.61415 5.99416 6.67119 6.2809 6.86185 6.47157L7.72379 7.3335L5.52851 9.52876C5.26817 9.7891 5.26817 10.2112 5.52851 10.4716C5.78887 10.7319 6.21097 10.7319 6.47133 10.4716L8.66659 8.2763L9.52852 9.13823C9.71919 9.3289 10.0059 9.38596 10.2551 9.28276C10.5042 9.17956 10.6666 8.9365 10.6666 8.66683V6.00016C10.6666 5.63198 10.3681 5.3335 9.99992 5.3335H7.33325Z" fill="#b2442c" />
                  </svg></a>
             </div>
           </div>
          </div>
       </div>
  
       <div className="col-lg-4  col-md-6" data-aos="fade-left" data-aos-duration="900">
        <div className="vl-blog-1-item">
           <div className="vl-blog-1-thumb image-anime">
              <img src="assets/img/all-images/blog/blog-img5.webp" alt="" />
           </div>
           <div className="vl-blog-1-content">
            <div className="vl-blog-meta">
               <ul>
                <li>
                  <a href="#">Articles</a>
              </li>
               </ul>
            </div>
            <div className="space16" />
            <h4 className="vl-blog-1-title"><a href="blog-single.html">What Is An Entrepreneurial Consultant? (Examples & Stories).</a></h4>
            <div className="space28" />
            <div className="vl-blog-1-icon">
             <a href="blog-single.html" className="learnmore">Learn More
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.99992 0.833496C4.04188 0.833496 0.833252 4.04212 0.833252 8.00016C0.833252 11.9582 4.04188 15.1668 7.99992 15.1668C11.958 15.1668 15.1666 11.9582 15.1666 8.00016C15.1666 4.04212 11.958 0.833496 7.99992 0.833496ZM7.33325 5.3335C7.06359 5.3335 6.82052 5.49592 6.71732 5.74504C6.61415 5.99416 6.67119 6.2809 6.86185 6.47157L7.72379 7.3335L5.52851 9.52876C5.26817 9.7891 5.26817 10.2112 5.52851 10.4716C5.78887 10.7319 6.21097 10.7319 6.47133 10.4716L8.66659 8.2763L9.52852 9.13823C9.71919 9.3289 10.0059 9.38596 10.2551 9.28276C10.5042 9.17956 10.6666 8.9365 10.6666 8.66683V6.00016C10.6666 5.63198 10.3681 5.3335 9.99992 5.3335H7.33325Z" fill="#b2442c" />
                  </svg></a>
           </div>
         </div>
        </div>
     </div>
     <div className="col-lg-4  col-md-6" data-aos="fade-left" data-aos-duration="900">
        <div className="vl-blog-1-item">
           <div className="vl-blog-1-thumb image-anime">
              <img src="assets/img/all-images/blog/blog-img6.png" alt="" />
           </div>
           <div className="vl-blog-1-content">
            <div className="vl-blog-meta">
               <ul>
                <li>
                  <a href="#">Articles</a>
              </li>
               </ul>
            </div>
            <div className="space16" />
            <h4 className="vl-blog-1-title"><a href="blog-single.html">What Is An Entrepreneurial Consultant? (Examples & Stories).</a></h4>
            <div className="space28" />
            <div className="vl-blog-1-icon">
             <a href="blog-single.html" className="learnmore">Learn More
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.99992 0.833496C4.04188 0.833496 0.833252 4.04212 0.833252 8.00016C0.833252 11.9582 4.04188 15.1668 7.99992 15.1668C11.958 15.1668 15.1666 11.9582 15.1666 8.00016C15.1666 4.04212 11.958 0.833496 7.99992 0.833496ZM7.33325 5.3335C7.06359 5.3335 6.82052 5.49592 6.71732 5.74504C6.61415 5.99416 6.67119 6.2809 6.86185 6.47157L7.72379 7.3335L5.52851 9.52876C5.26817 9.7891 5.26817 10.2112 5.52851 10.4716C5.78887 10.7319 6.21097 10.7319 6.47133 10.4716L8.66659 8.2763L9.52852 9.13823C9.71919 9.3289 10.0059 9.38596 10.2551 9.28276C10.5042 9.17956 10.6666 8.9365 10.6666 8.66683V6.00016C10.6666 5.63198 10.3681 5.3335 9.99992 5.3335H7.33325Z" fill="#b2442c" />
                  </svg></a>
           </div>
         </div>
        </div>
     </div>
       </div>
    </div>
  </div>
  { /*===== BLOG AREA ENDS =======*/ }

<Cta/>
</>
    );
}

export default Blogs;